import Vue from 'vue'                   // Core
import App from './App.vue'             // Componente principal
import router from './router'           // Configuración de router
import store from './store/'            // Stores
import bootstrap from 'bootstrap'       // Bootstrap

// Font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Filtros
import './filters/fechas'
import './filters/numeros'
import './filters/strings'

// Resource, para ajax
import VueResource from 'vue-resource'
Vue.use(VueResource);
Vue.http.interceptors.push(function(request, next) {
  let authHeader = 'Bearer ' + store.getters.credentials.token
  request.headers.set('Authorization', authHeader)
  request.headers.set('Platform', 'web-clientes')
  request.headers.set('Url', window.location.href)
  next()
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
